export const SITE_URL = 'https://opsynk.com'

export const SEO_LOCALES = ['sv', 'en'] as const
export type SeoLocale = (typeof SEO_LOCALES)[number]

export const X_DEFAULT_LOCALE: SeoLocale = 'en'

export type RouteType =
  | 'home'
  | 'product'
  | 'industry'
  | 'hub'
  | 'guide'
  | 'template'
  | 'comparison'
  | 'blog-index'
  | 'blog-post'
  | 'company'
  | 'legal'
  | 'utility'

export type RouteStatus = 'published' | 'review' | 'draft'

export interface RouteEntry {
  key: string
  paths: Record<SeoLocale, string>
  locales?: readonly SeoLocale[]
  legacySlug?: string | false
  type: RouteType
  indexable: boolean
  status: RouteStatus
  updatedAt: string
  equivalent: boolean
  parent?: string
}

export const ROUTES = [
  {
    key: '/',
    paths: { sv: '/', en: '/' },
    type: 'home',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
  },
  {
    key: '/workorder',
    paths: { sv: '/arbetsordersystem', en: '/workorder' },
    type: 'product',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/checklist',
    paths: { sv: '/ronderingssystem', en: '/checklist' },
    type: 'product',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/planning',
    paths: { sv: '/planeringssystem', en: '/planning' },
    type: 'product',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/clients',
    paths: { sv: '/kundregister', en: '/clients' },
    type: 'product',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/features',
    paths: { sv: '/funktioner', en: '/features' },
    type: 'product',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/industries',
    paths: { sv: '/branscher', en: '/industries' },
    locales: ['sv'],
    legacySlug: false,
    type: 'hub',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/',
  },
  {
    key: '/industries/snow-clearing',
    paths: { sv: '/branscher/snorojning', en: '/industries/snow-clearing' },
    locales: ['sv'],
    legacySlug: false,
    type: 'industry',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/industries',
  },
  {
    key: '/industries/property-services',
    paths: { sv: '/branscher/fastighetsservice', en: '/industries/property-services' },
    locales: ['sv'],
    legacySlug: false,
    type: 'industry',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/industries',
  },
  {
    key: '/industries/cleaning',
    paths: { sv: '/branscher/stadning', en: '/industries/cleaning' },
    locales: ['sv'],
    legacySlug: false,
    type: 'industry',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/industries',
  },
  {
    key: '/gardening',
    paths: { sv: '/branscher/tradgard', en: '/gardening' },
    type: 'industry',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/industries',
  },
  {
    key: '/about',
    paths: { sv: '/om-oss', en: '/about' },
    legacySlug: false,
    type: 'company',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/contact',
    paths: { sv: '/kontakt', en: '/contact' },
    legacySlug: false,
    type: 'company',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/guides',
    paths: { sv: '/guider', en: '/guides' },
    locales: ['sv'],
    legacySlug: false,
    type: 'hub',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/',
  },
  {
    key: '/guides/what-is-a-work-order',
    paths: { sv: '/guider/vad-ar-en-arbetsorder', en: '/guides/what-is-a-work-order' },
    locales: ['sv'],
    legacySlug: false,
    type: 'guide',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/guides',
  },
  {
    key: '/guides/rounds',
    paths: { sv: '/guider/rondering', en: '/guides/rounds' },
    locales: ['sv'],
    legacySlug: false,
    type: 'guide',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/guides',
  },
  {
    key: '/guides/work-order-system-cost',
    paths: { sv: '/guider/vad-kostar-ett-arbetsordersystem', en: '/guides/work-order-system-cost' },
    locales: ['sv'],
    legacySlug: false,
    type: 'guide',
    indexable: true,
    status: 'review',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/guides',
  },
  {
    key: '/guides/invoice-basis',
    paths: { sv: '/guider/fakturaunderlag', en: '/guides/invoice-basis' },
    locales: ['sv'],
    legacySlug: false,
    type: 'guide',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/guides',
  },
  {
    key: '/guides/field-service-system',
    paths: { sv: '/guider/faltservicesystem', en: '/guides/field-service-system' },
    locales: ['sv'],
    legacySlug: false,
    type: 'guide',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/guides',
  },
  {
    key: '/templates',
    paths: { sv: '/mallar', en: '/templates' },
    locales: ['sv'],
    legacySlug: false,
    type: 'hub',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/',
  },
  {
    key: '/templates/work-order',
    paths: { sv: '/mallar/arbetsorder', en: '/templates/work-order' },
    locales: ['sv'],
    legacySlug: false,
    type: 'template',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/templates',
  },
  {
    key: '/templates/property-round',
    paths: { sv: '/mallar/rondering-fastighet', en: '/templates/property-round' },
    locales: ['sv'],
    legacySlug: false,
    type: 'template',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/templates',
  },
  {
    key: '/templates/round-protocol',
    paths: { sv: '/mallar/ronderingsprotokoll', en: '/templates/round-protocol' },
    locales: ['sv'],
    legacySlug: false,
    type: 'template',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/templates',
  },
  {
    key: '/templates/safety-round',
    paths: { sv: '/mallar/skyddsrond', en: '/templates/safety-round' },
    locales: ['sv'],
    legacySlug: false,
    type: 'template',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/templates',
  },
  {
    key: '/compare/work-order-systems',
    paths: { sv: '/jamfor/arbetsordersystem', en: '/compare/work-order-systems' },
    locales: ['sv'],
    legacySlug: false,
    type: 'comparison',
    indexable: true,
    status: 'review',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/',
  },
  {
    key: '/compare/excel',
    paths: { sv: '/jamfor/excel', en: '/compare/excel' },
    locales: ['sv'],
    legacySlug: false,
    type: 'comparison',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-27',
    equivalent: false,
    parent: '/',
  },
  {
    key: '/blog',
    paths: { sv: '/blogg', en: '/blog' },
    type: 'blog-index',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/blog/[articleId]',
    paths: { sv: '/blogg/[articleId]', en: '/blog/[articleId]' },
    type: 'blog-post',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: false,
    parent: '/blog',
  },
  {
    key: '/roadmap',
    paths: { sv: '/roadmap', en: '/roadmap' },
    type: 'company',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/beta',
    paths: { sv: '/beta', en: '/beta' },
    type: 'company',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/beta/thank-you',
    paths: { sv: '/beta/thank-you', en: '/beta/thank-you' },
    type: 'utility',
    indexable: false,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/beta',
  },
  {
    key: '/terms',
    paths: { sv: '/terms', en: '/terms' },
    type: 'legal',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/privacy',
    paths: { sv: '/privacy', en: '/privacy' },
    type: 'legal',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/cookie',
    paths: { sv: '/cookie', en: '/cookie' },
    type: 'legal',
    indexable: true,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
  {
    key: '/try-demo',
    paths: { sv: '/try-demo', en: '/try-demo' },
    type: 'utility',
    indexable: false,
    status: 'published',
    updatedAt: '2026-10-26',
    equivalent: true,
    parent: '/',
  },
] as const satisfies readonly RouteEntry[]

export type RouteKey = (typeof ROUTES)[number]['key']
export type StaticRouteKey = Exclude<RouteKey, `${string}[${string}`>

const routeMap = new Map<string, RouteEntry>(ROUTES.map((route) => [route.key, route]))

export const getRoute = (key: RouteKey): RouteEntry => routeMap.get(key)!

export const routeLocales = (route: RouteEntry): readonly SeoLocale[] => route.locales ?? SEO_LOCALES

export const isAvailable = (key: string, locale: SeoLocale) => {
  const route = routeMap.get(key)
  return !!route && isLive(route) && routeLocales(route).includes(locale)
}

export const isDynamicPath = (path: string) => path.includes('[')

export const fillPath = (path: string, params: Record<string, string> = {}) =>
  path.replace(/\[(\w+)\]/g, (_, name: string) => encodeURIComponent(params[name] ?? ''))

export const localizedPath = (key: RouteKey, locale: SeoLocale, params?: Record<string, string>) => {
  const path = fillPath(getRoute(key).paths[locale], params)
  return path === '/' ? `/${locale}` : `/${locale}${path}`
}

export const absoluteUrl = (key: RouteKey, locale: SeoLocale, params?: Record<string, string>) => `${SITE_URL}${localizedPath(key, locale, params)}`

export const templateSlug = (route: RouteEntry) => route.paths.sv.split('/').pop()!

export const SHOW_REVIEW_CONTENT = process.env.NODE_ENV !== 'production' || process.env.NEXT_PUBLIC_SHOW_REVIEW_CONTENT === 'true'

export const isLiveKey = (key: string) => {
  const route = routeMap.get(key)
  return !!route && isLive(route)
}

export const isLive = (route: RouteEntry) => route.status === 'published' || (SHOW_REVIEW_CONTENT && route.status === 'review')

export const breadcrumbTrail = (key: RouteKey, locale?: SeoLocale): RouteKey[] => {
  const trail: RouteKey[] = []
  let current: RouteEntry | undefined = getRoute(key)
  while (current) {
    if (!locale || routeLocales(current).includes(locale)) trail.unshift(current.key as RouteKey)
    current = current.parent ? routeMap.get(current.parent) : undefined
  }
  return trail
}

export const intlPathnames = Object.fromEntries(ROUTES.map((route) => [route.key, route.paths])) as {
  [R in (typeof ROUTES)[number] as R['key']]: R['paths']
}

const toPattern = (path: string) => path.replace(/\[(\w+)\]/g, ':$1')

const prefixed = (locale: SeoLocale, path: string) => (path === '/' ? `/${locale}` : `/${locale}${path}`)

export interface LegacyRedirect {
  source: string
  destination: string
  prefixed: boolean
}

export const legacyRedirects = (): LegacyRedirect[] => {
  const redirects: LegacyRedirect[] = [{ source: '/', destination: '/sv', prefixed: false }]
  for (const route of ROUTES as readonly RouteEntry[]) {
    if (route.legacySlug === false) continue
    const legacy = route.legacySlug ?? route.paths.en
    if (legacy !== '/') {
      redirects.push({ source: toPattern(legacy), destination: toPattern(prefixed('sv', route.paths.sv)), prefixed: false })
    }
    for (const locale of SEO_LOCALES) {
      if (legacy !== route.paths[locale]) {
        redirects.push({
          source: toPattern(prefixed(locale, legacy)),
          destination: toPattern(prefixed(locale, route.paths[locale])),
          prefixed: true,
        })
      }
    }
  }
  return redirects
}

const compiledRedirects = () =>
  legacyRedirects().map((redirect) => {
    const names: string[] = []
    const pattern = redirect.source.replace(/:(\w+)/g, (_, name: string) => {
      names.push(name)
      return '([^/]+)'
    })
    return { regex: new RegExp(`^${pattern}$`), names, destination: redirect.destination }
  })

let redirectCache: ReturnType<typeof compiledRedirects> | undefined

export const matchLegacyRedirect = (pathname: string): string | undefined => {
  redirectCache ??= compiledRedirects()
  for (const redirect of redirectCache) {
    const match = redirect.regex.exec(pathname)
    if (!match) continue
    return redirect.names.reduce((destination, name, index) => destination.replace(`:${name}`, match[index + 1]!), redirect.destination)
  }
  return undefined
}
